import Header from "@/components/Header"
import Footer from "@/components/Footer"
import VendorDashboardContent from "@/components/vendor/VendorDashboardContent"

const VendorDashboard = () => {
  return (
    <div className="min-h-screen bg-background text-foreground transition-colors duration-300">
      <Header />

      <main className="w-full">
        <VendorDashboardContent />
      </main>

      <Footer />
    </div>
  )
}

export default VendorDashboard

